import './LoadingSpinner.scss';

import classNames from 'classnames';
import { usePrevious } from '@hooks';

import React, { useEffect, useRef, useState } from 'react';
import { Spin, SpinProps } from 'antd';

export type LoadingSpinnerProps = SpinProps & {
    divClassName?: string;
	minDuration?: number;
	opaque?: boolean;
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
	children,
	divClassName,
	spinning = false,
	minDuration = 0,
	opaque,
	size = 'large',
	...rest
}) => {
	const timeoutId = useRef<NodeJS.Timeout>();
	const [ minLoading, setMinLoading ] = useState(false);
	const previousSpinning = usePrevious(spinning);

	useEffect(() => {
		if (spinning && !previousSpinning) {
			setMinLoading(true);

			if (timeoutId.current) {
				clearTimeout(timeoutId.current);
			}

			timeoutId.current = setTimeout(() => {
				setMinLoading(false);
			}, minDuration);
		}
	}, [ spinning, minDuration, previousSpinning ]);


	return (
		<div
			className={ classNames('loading-spinner', divClassName, {
				'empty-spinner': !children,
				opaque
			}) }>
			<Spin
				size={ size }
				spinning={ spinning || minLoading }
				{ ...rest }>
				{ children }
			</Spin>
		</div>
	);
};


